import React from "react";
import CustomerRepresenterAddForm from "./CustomerRepresenterAddForm";
import MainPageCompenent from './MainPageCompenent';
function CustomerRepresenterAdd(props) {
    return (
        <MainPageCompenent>
            <CustomerRepresenterAddForm />
        </MainPageCompenent>
    );
}

export default CustomerRepresenterAdd;